// extracted by mini-css-extract-plugin
export default {"check":"SettingsGear_check__f0yfr","header":"SettingsGear_header__1KjtK","placeHolderShimmer":"SettingsGear_placeHolderShimmer__A4Okj"};